import type { DripsyColor } from "@utils";
import { useDripsyColor } from "@utils";
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";

function ClockIcon2({ size, color }: { size: number; color: DripsyColor }) {
  const newColor = useDripsyColor({ color });
  return (
    <Svg height={size} viewBox="0 0 347.442 347.442" width={size} fill={newColor}>
      <G>
        <G>
          <Path d="m173.721 347.442c95.919 0 173.721-77.802 173.721-173.721s-77.802-173.721-173.721-173.721-173.721 77.802-173.721 173.721 77.802 173.721 173.721 173.721zm-12.409-272.99c0-6.825 5.584-12.409 12.409-12.409s12.409 5.584 12.409 12.409v93.313l57.39 45.912c5.336 4.281 6.204 12.098 1.923 17.434-2.42 3.04-6.018 4.653-9.679 4.653-2.73 0-5.46-.869-7.755-2.73l-62.043-49.634c-2.916-2.358-4.653-5.894-4.653-9.679v-99.269z" />
        </G>
      </G>
    </Svg>
  );
}
export default ClockIcon2;
